import { __assign, __read } from "tslib";
import React, { useEffect, useRef, useState } from 'react';
import { hasContentOverflow } from '@keen.io/charts-utils';
import { Container, Layout } from './series-vertical.styles';
import Slider from '../slider';
import Card from '../card';
import { createSliderTransition } from '../legend.utils';
import { BUTTON_DIMENSION, BUTTON_SHADOW_SIZE } from '../slider-button';
var SeriesVertical = function (_a) {
    var card = _a.card, alignment = _a.alignment, colorPalette = _a.colorPalette, dataSeries = _a.dataSeries, renderNodes = _a.renderNodes, _b = _a.itemWidth, itemWidth = _b === void 0 ? 100 : _b, _c = _a.itemGap, itemGap = _c === void 0 ? 10 : _c, onOffsetUpdate = _a.onOffsetUpdate;
    var containerRef = useRef(null);
    var elementRef = useRef(null);
    var _d = __read(useState(false), 2), calculationReady = _d[0], setCalculationReady = _d[1];
    var _e = __read(useState([
        0,
        colorPalette.length,
    ]), 2), dataSeriesOffset = _e[0], setDataSeriesOffset = _e[1];
    var _f = __read(useState('list'), 2), renderMode = _f[0], setRenderMode = _f[1];
    var _g = __read(useState(0), 2), elementHeight = _g[0], setElementHeight = _g[1];
    var _h = __read(useState([
        0,
        0,
    ]), 2), sliderDimension = _h[0], setSliderDimension = _h[1];
    var _j = __read(useState(0), 2), direction = _j[0], setDirection = _j[1];
    useEffect(function () {
        if (renderMode === 'slider') {
            var colorsInPallete = colorPalette.length;
            var containerHeight = containerRef.current.offsetHeight;
            var dimensionCapacity = Math.floor((containerHeight - 2 * (BUTTON_DIMENSION + BUTTON_SHADOW_SIZE)) /
                (elementHeight + itemGap));
            var itemsInSlider_1 = dimensionCapacity > colorsInPallete
                ? colorsInPallete
                : dimensionCapacity;
            var sliderHeight_1 = itemsInSlider_1 * (elementHeight + itemGap) +
                2 * (BUTTON_DIMENSION + BUTTON_SHADOW_SIZE) -
                itemGap;
            setSliderDimension(function (_a) {
                var _b = __read(_a, 1), width = _b[0];
                return [width, sliderHeight_1];
            });
            setDataSeriesOffset([0, itemsInSlider_1]);
            setCalculationReady(true);
        }
    }, [renderMode]);
    useEffect(function () {
        var notEnoughColors = dataSeries.length > colorPalette.length;
        var contentOverflow = hasContentOverflow('vertical', containerRef.current);
        if (contentOverflow || notEnoughColors) {
            var height = elementRef.current.getBoundingClientRect().height;
            setElementHeight(height);
            var sliderHeight = containerRef.current.offsetHeight;
            var sliderWidth = containerRef.current.offsetWidth;
            setSliderDimension([sliderWidth, sliderHeight]);
            setRenderMode('slider');
        }
        else {
            setCalculationReady(true);
        }
    }, []);
    var _k = __read(dataSeriesOffset, 2), startOffset = _k[0], endOffset = _k[1];
    var itemsInSlider = endOffset - startOffset;
    useEffect(function () {
        onOffsetUpdate([startOffset, endOffset]);
    }, [startOffset, endOffset]);
    return (React.createElement("div", { style: {
            height: '100%',
            maxWidth: '100%',
            position: 'relative',
        } },
        React.createElement(Container, { calculationReady: calculationReady, alignment: alignment, ref: containerRef },
            React.createElement(Card, __assign({ borderPosition: "top" }, card), renderMode === 'list' ? (React.createElement(Layout, { itemSpace: itemGap }, renderNodes(dataSeries.slice(0, colorPalette.length), elementRef, itemWidth))) : (React.createElement(Slider, { mode: "vertical", dimension: sliderDimension, nextDisabled: endOffset >= dataSeries.length, previousDisabled: startOffset === 0, direction: direction, animation: function (itemIndex) {
                    return createSliderTransition('vertical', itemIndex, elementHeight, itemGap, sliderDimension[1]);
                }, onNextSlide: function () {
                    setDataSeriesOffset(function (_a) {
                        var _b = __read(_a, 2), startOffset = _b[0], endOffset = _b[1];
                        return [
                            startOffset + itemsInSlider,
                            endOffset + itemsInSlider,
                        ];
                    });
                    setDirection(1);
                }, onPreviousSlide: function () {
                    setDataSeriesOffset(function (_a) {
                        var _b = __read(_a, 2), startOffset = _b[0], endOffset = _b[1];
                        return [
                            startOffset - itemsInSlider,
                            endOffset - itemsInSlider,
                        ];
                    });
                    setDirection(-1);
                } }, renderNodes(dataSeries.slice(dataSeriesOffset[0], dataSeriesOffset[1]), elementRef, itemWidth)))))));
};
export default SeriesVertical;
